import React from "react";
import { Row, Col, Tag, Typography, Space } from "antd";
import { CarOutlined } from "@ant-design/icons";
import THEME from "../theme";
import StyledCard from "../components/StyledCard";
import InfoItem from "../components/InfoItem";

const { Title, Text } = Typography;

const MortgageInfoTab = ({ loanData }) => {
  const mortgage = loanData?.MORTGAGE;
  if (!mortgage) return;
  return (
    <StyledCard
      title="ข้อมูลหลักประกัน"
      icon={<CarOutlined style={{ color: THEME.primary, fontSize: 18 }} />}
    >
      <Row gutter={[24, 16]}>
        <Col xs={24} md={12}>
          <div
            style={{
              background: `linear-gradient(135deg, ${THEME.light} 0%, #e2e8f0 100%)`,
              padding: 20,
              borderRadius: 10,
              marginBottom: 16,
            }}
          >
            <Space direction="vertical" style={{ width: "100%" }}>
              <Text type="secondary" style={{ fontSize: 14 }}>
                ยี่ห้อ / รุ่น
              </Text>
              <Title level={4} style={{ margin: 0, color: THEME.primary }}>
                {mortgage?.TYPE} {mortgage?.MODEL}
              </Title>
              <Text>{mortgage?.BAAB}</Text>
              <Space>
                <Tag color="blue">ปี {mortgage?.MANUYR}</Tag>
                <Tag color="geekblue">สี{mortgage?.COLOR}</Tag>
              </Space>
            </Space>
          </div>
        </Col>
        <Col xs={24} md={12}>
          <Row gutter={[16, 12]}>
            <Col span={12}>
              <InfoItem
                label="ทะเบียนรถ"
                value={
                  <Text copyable style={{ fontFamily: "monospace" }}>
                    {mortgage?.REGNO}
                  </Text>
                }
              />
            </Col>
            <Col span={12}>
              <InfoItem
                label="จังหวัด"
                value={
                  <Text copyable style={{ fontFamily: "monospace" }}>
                    {mortgage?.DORECV}
                  </Text>
                }
              />
            </Col>
            <Col span={24}>
              <InfoItem
                label="เลขตัวถัง"
                value={
                  <Text copyable style={{ fontFamily: "monospace" }}>
                    {mortgage?.STRNO}
                  </Text>
                }
              />
            </Col>
            <Col span={24}>
              <InfoItem
                label="เลขเครื่อง"
                value={
                  <Text copyable style={{ fontFamily: "monospace" }}>
                    {mortgage?.ENGNO}
                  </Text>
                }
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </StyledCard>
  );
};

export default MortgageInfoTab;
